import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SSOLogin } from '@/components/auth/SSOLogin';
import { SSORegister } from '@/components/auth/SSORegister';

export default function LoginPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  const handleSSOSuccess = () => {
    navigate('/dashboard');
  };

  const handleSSOError = (err: string) => {
    setError(err);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to Phino LMS
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Continue with your organization&apos;s SSO
          </p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded text-sm">
            {error}
          </div>
        )}

        <div className="bg-white shadow rounded-lg p-6 space-y-6">
          <div>
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wide mb-4">
              Already have an account?
            </h3>
            <SSOLogin onSuccess={handleSSOSuccess} onError={handleSSOError} />
          </div>

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white text-gray-500">Or</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wide mb-4">
              New to Phino LMS?
            </h3>
            <SSORegister onSuccess={handleSSOSuccess} onError={handleSSOError} />
          </div>
        </div>

        <p className="text-center text-sm text-gray-500">
          <Link to="/" className="text-blue-600 hover:underline">
            Back to home
          </Link>
        </p>
      </div>
    </div>
  );
}
